// src/components/BasePage.tsx
import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "./Header";
import Footer from "./Footer";

interface BasePageProps {
  title: string;
  description: string;
  keywords?: string;
  children: React.ReactNode;
  hideFooter?: boolean;
}

const BasePage: React.FC<BasePageProps> = ({
  title,
  description,
  keywords,
  children,
  hideFooter,
}) => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        {keywords && <meta name="keywords" content={keywords} />}
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta charSet="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      </Helmet>

      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-1 relative z-0 overflow-visible">{children}</main>
        {!hideFooter && <Footer />}
      </div>
    </>
  );
};

export default BasePage;
